module.exports = __webpack_public_path__ + "media/images/athletes/2806-9c9ba55e22766055a3fd4de41c1277d3.png";